import { DictionaryModel } from '../models/DictionaryModel';
import emptySliceApi from '../store/emptyApiSlice';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getDictionary: builder.query<DictionaryModel, { name: string }>({
      query: ({ name }) => `/dictionary/${name}`,
    }),
  }),
});

export const { useGetDictionaryQuery } = apiSlice;
